import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_COMMS_STACK_DM_ADDED_ENGAGEMENT_VALUE_PROPS_ENABLED = defineFcm(
	'comms_stack_dm_added_engagement_value_props_enabled',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			optional: true,
			shape: {
				enabled: { type: 'boolean' },
				supportedLocales: {
					type: 'array',
					shape: { type: 'string' },
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		supportedLocales: [],
	})
	.toConfig({
		owner: 'squad-capybara',
		scope: 'comms-stack',
		context: 'Allow sending new email template when a decision maker is added',
		description: `Upon adding a decision maker, a new email template with some value propositions has been created.
			This FC permits switching between the old and new template. FC should be enabled by country. Locale preferences should set within the "supportedLocales" property`,
		import: false,
		template: {
			enabled: false,
			supportedLocales: ['en-US'],
		},
	});
